import React from 'react'
import { Layout as AntdLayout } from 'antd'
import { LayoutProps, SiderProps } from 'antd/es/layout'
import cx from 'classnames'
import { CommutifiFooter, CommutifiFooterProps } from './CommutifiFooter'
import './styles.scss'

export type { LayoutProps, SiderProps }

const PrefixCls = 'app-divider'

/**
 * This class is a wrap around [antd Divider](https://ant.design/components/divider/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */
function InternalLayout({ className, ...props }: LayoutProps) {
  return <AntdLayout {...props} className={cx(PrefixCls, className)} />
}

type LayoutType = typeof InternalLayout
interface LayoutInterface extends LayoutType {
  Content: typeof AntdLayout.Content
  CommutifiFooter: typeof AppFooter
  Footer: typeof AntdLayout.Footer
  Header: typeof AntdLayout.Header
  Sider: typeof AntdLayout.Sider
  displayName?: string
  defaultProps?: typeof AntdLayout.defaultProps
}
export const Layout = InternalLayout as LayoutInterface

function AppFooter({ rootClassName, ...props }: CommutifiFooterProps & { rootClassName?: string }) {
  return (
    <Layout.Footer className={cx('app-commutifi-footer', rootClassName)}>
      <CommutifiFooter {...props} />
    </Layout.Footer>
  )
}
AppFooter.OfflineLocaleSelector = CommutifiFooter.OfflineLocaleSelector

Layout.Content = AntdLayout.Content
Layout.CommutifiFooter = AppFooter
Layout.Footer = AntdLayout.Footer
Layout.Header = AntdLayout.Header
Layout.Sider = AntdLayout.Sider
Layout.displayName = AntdLayout.displayName
Layout.defaultProps = AntdLayout.defaultProps
